import {Service} from '@s-ui/domain'

export default class GetScreensetService extends Service {
  constructor({repository}) {
    super({repository})

    this._repository = repository
  }

  async execute({urlVars}) {
    return this._repository.getScreenset({urlVars})
  }
}
